import {User} from "../user.model";

export class BillingHolder {

  billingStatsList: {month:'', totalBillable: 0, totalOffDuty: 0, billed: 0, displayInDayFormat: false} [];
  user: User;
  selectedYear: string;

  constructor(messageJSON: any) {
    this.billingStatsList = messageJSON.billingStatsList;
    this.user = messageJSON.user;
    this.selectedYear = messageJSON.selectedYear
  }
}
